export interface NewsInterest {
  label: string;
  slug: string;
}

export interface NewsInterestCategory {
  name: string;
  subcategories: NewsInterest[];
}

export const NEWS_INTEREST_CATEGORIES: NewsInterestCategory[] = [
  {
    name: 'National',
    subcategories: [
      { label: 'Top Stories', slug: 'topstories' },
      { label: 'World', slug: 'world' },
      { label: 'Canada', slug: 'canada' },
      { label: 'Politics', slug: 'politics' },
      { label: 'Business', slug: 'business' },
      { label: 'Health', slug: 'health' },
      { label: 'Arts', slug: 'arts' },
      { label: 'Technology', slug: 'technology' },
      { label: 'Indigenous', slug: 'indigenous' },
    ],
  },
  {
    name: 'Sports',
    subcategories: [
      { label: 'General', slug: 'sports' },
      { label: 'MLB', slug: 'sports-mlb' },
      { label: 'NBA', slug: 'sports-nba' },
      { label: 'Curling', slug: 'sports-curling' },
      { label: 'CFL', slug: 'sports-cfl' },
      { label: 'NFL', slug: 'sports-nfl' },
      { label: 'NHL', slug: 'sports-nhl' },
      { label: 'Soccer', slug: 'sports-soccer' },
      { label: 'Figure Skating', slug: 'sports-figureskating' },
      { label: 'Golf', slug: 'sports-golf' },
      { label: 'Olympic', slug: 'sports-olympics' },
      { label: 'Skiing', slug: 'sports-skiing' },
      { label: 'Tennis', slug: 'sports-tennis' },
    ],
  },
  {
    name: 'Regional',
    subcategories: [
      { label: 'British Columbia', slug: 'canada-britishcolumbia' },
      { label: 'Kamloops', slug: 'canada-kamloops' },
      { label: 'Calgary', slug: 'canada-calgary' },
      { label: 'Edmonton', slug: 'canada-edmonton' },
      { label: 'Saskatchewan', slug: 'canada-saskatchewan' },
      { label: 'Saskatoon', slug: 'canada-saskatoon' },
      { label: 'Manitoba', slug: 'canada-manitoba' },
      { label: 'Thunder Bay', slug: 'canada-thunderbay' },
      { label: 'Sudbury', slug: 'canada-sudbury' },
      { label: 'Windsor', slug: 'canada-windsor' },
      { label: 'London', slug: 'canada-london' },
      { label: 'Kitchener-Waterloo', slug: 'canada-kitchenerwaterloo' },
      { label: 'Toronto', slug: 'canada-toronto' },
      { label: 'Hamilton', slug: 'canada-hamilton' },
      { label: 'Montreal', slug: 'canada-montreal' },
      { label: 'New Brunswick', slug: 'canada-newbrunswick' },
      { label: 'PEI', slug: 'canada-pei' },
      { label: 'Nova Scotia', slug: 'canada-novascotia' },
      { label: 'Newfoundland & Labrador', slug: 'canada-newfoundland' },
      { label: 'North', slug: 'canada-north' },
      { label: 'Ottawa', slug: 'canada-ottawa' },
    ],
  },
];

// Build a slug -> label lookup map
const slugLabelMap = new Map<string, string>();
NEWS_INTEREST_CATEGORIES.forEach((cat) =>
  cat.subcategories.forEach((sub) => slugLabelMap.set(sub.slug, sub.label))
);

export function slugToLabel(slug: string): string {
  return slugLabelMap.get(slug) || slug;
}
